import {Action, handleActions} from "redux-actions";
import {UserLocationState} from "./UserLocationState";
import {none, option} from "ts-option";
import {USER_LOCATIONS_FETCHED} from "../../action/userLocation/actionType";

/**
 * Initial state for user locations.
 */
const initState: UserLocationState = {
	userLocations: none,
};

const reducer = handleActions({
	[USER_LOCATIONS_FETCHED]: (state: UserLocationState, action: Action<USER_LOCATIONS_FETCHED>): UserLocationState => {
		return {...state, userLocations: option(action.payload.userLocations)}
	}
}, initState);

export default reducer;